import ApplicationList from "./ApplicationList";

export default ApplicationList;